import {twx} from '../../../utils/tailwindUtils';

const AiAssistantSettingCard = ({className, children}) => (
    <div className={twx('flex flex-1 gap-3 rounded-xl bg-[#1C1C1D] p-4', className)}>{children}</div>
);

export default AiAssistantSettingCard;
